import { useService } from "./service.js";
import { getRaf as getRequestAnimationFrame } from "../utils/nextFrame.js";
import { useScheduler } from "../utils/scheduler.js";
import { isFunction } from "../utils/is.js";
const scheduler = useScheduler(["update", "render"]);
function createRafService() {
  let isTicking = false;
  const RAF = getRequestAnimationFrame();
  function trigger(props2) {
    callbacks.forEach(function forEachCallback(callback) {
      scheduler.update(function rafUpdate() {
        const render = callback(props2);
        if (isFunction(render)) {
          scheduler.render(function rafRender() {
            render(props2);
          });
        }
      });
    });
  }
  function loop() {
    props.time = performance.now();
    trigger(props);
    if (!isTicking) {
      return;
    }
    RAF(loop);
  }
  const { add, remove, has, props, callbacks } = useService({
    props: {
      time: performance.now()
    },
    init() {
      isTicking = true;
      RAF(loop);
    },
    kill() {
      isTicking = false;
    }
  });
  return {
    add,
    remove,
    has,
    props: () => props
  };
}
let raf;
function useRaf() {
  if (!raf) {
    raf = createRafService();
  }
  return raf;
}
export {
  useRaf as default
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
